import { jsx as _jsx } from "react/jsx-runtime";
import Box from '@mui/material/Box';
export default function HighlightText({ children }) {
    return (_jsx(Box, { component: 'span', sx: { display: 'inline-block', color: '#F88D58' }, children: children }));
}
